import React, { useState } from 'react';
import { Drawer, Tooltip, Tabs } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { ExportTitle } from '@src/components/ActionToolbar/More/ExportOption/components/ExportTitle';
import { track } from '@src/utils';
import { CLICK_EXPORT_OVERVIEW } from '@src/utils/sensor/track';
import { ToggleButton } from '@src/components/common/Utils/Buttons';
import { PAGE_TYPE } from '@src/utils/constants';
import RegularExport from './RegularExport';
import BenchmarkExportDrawer from './AdvancedExport';
import { StyledTabsWrapper } from './styled';

interface OverviewExportOptionProps {
  pageType?: number;
}

const OverviewExportOption: React.FC<OverviewExportOptionProps> = ({ pageType }) => {
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('regular');
  const [drawerFooter, setDrawerFooter] = useState<React.ReactNode>(null);

  const showDrawer = () => {
    track({ event: CLICK_EXPORT_OVERVIEW });
    setActiveTab('regular');
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  // Show advanced export only in main overview (not in shared views)
  const showAdvancedExport = pageType !== PAGE_TYPE.SHARING;

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  const tabItems = [
    {
      key: 'regular',
      label: 'Dashboard Export',
      children: (
        <div>
          {activeTab === 'regular' && (
            <RegularExport onClose={onClose} visible={open} onFooterRender={setDrawerFooter} />
          )}
        </div>
      ),
    },
    ...(showAdvancedExport
      ? [
          {
            key: 'advanced',
            label: 'Benchmark Export (Advanced)',
            children: (
              <div>
                {activeTab === 'advanced' && (
                  <BenchmarkExportDrawer
                    visible={open}
                    onClose={onClose}
                    currentShareId=""
                    pageType={pageType || 0}
                    onFooterRender={setDrawerFooter}
                  />
                )}
              </div>
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <Tooltip title="Export Benchmark and Overview data">
        <ToggleButton
          onClick={showDrawer}
          icon={<DownloadOutlined />}
          style={{ margin: '0 0 0 10px' }}
        />
      </Tooltip>
      <Drawer
        title={<ExportTitle />}
        onClose={onClose}
        open={open}
        width={800}
        closeIcon={false}
        footer={drawerFooter}
        styles={{
          body: {
            padding: 0,
            height: 'calc(100vh - 55px)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          },
        }}
      >
        <StyledTabsWrapper>
          <Tabs activeKey={activeTab} onChange={handleTabChange} items={tabItems} />
        </StyledTabsWrapper>
      </Drawer>
    </>
  );
};

export default OverviewExportOption;
